import { FC, useMemo } from 'react';

import { GProduct, Variant } from '@/types';
import { useActiveProductBadges } from 'hooks/useActiveProductBadges';
import ProductBadge from '../Product/ProductBadge';

interface IProductBadgesProps {
  product: GProduct;
  weightVariant: Variant;
}

const ProductBadges: FC<IProductBadgesProps> = ({ product, weightVariant }) => {
  const { badges, shouldRender } = useActiveProductBadges({
    product,
    weightVariant,
    isDetail: true,
  });

  const renderedBadges = useMemo(
    () =>
      badges.map(({ props }, index) => <ProductBadge {...props} key={index} />),
    [badges],
  );

  if (!shouldRender || badges.length === 0) return null;

  return <div className="product__badges">{renderedBadges}</div>;
};

export { ProductBadges };
